var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductTranslationService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6H37C41.9706 6 46 10.0294 46 15V25C46 29.9706 41.9706 34 37 34H21L13 45V34C8.02944 34 4 29.9706 4 25V15C4 10.0294 8.02944 6 13 6Z",
    stroke: "#DADADA",
    strokeWidth: 5.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 26H61C65.9706 26 70 30.0294 70 35V45C70 49.9706 65.9706 54 61 54V65L53 54H37C32.0294 54 28 49.9706 28 45V35C28 30.0294 32.0294 26 37 26Z",
    fill: "url(#translationGradient)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "translationGradient",
    x1: 28,
    y1: 26,
    x2: 70,
    y2: 65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7948AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49B7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductTranslationService);
export default __webpack_public_path__ + "static/media/product_translation_service.94c2c3621c32fcf0b50869bc21c071fc.svg";
export { ForwardRef as ReactComponent };